
export class GetQualitySurveyCommand {
  constructor(
    public surveyId: string,
    public valueAssessmentId: string  ) { }
}
